import { createGlobalState } from 'react-hooks-global-state';

const { setGlobalState, useGlobalState } = createGlobalState({
  synonymModal: [],
  ignoredWords: JSON.parse(localStorage.getItem('ignoredWords')) || []
});

export { useGlobalState, setGlobalState };
